define( [
	"./hasOwn"
], function( hasOwn ) {
	"use strict";

	return hasOwn.toString;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/fnToString.js
 ** module id = 311
 ** module chunks = 0
 **/